import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { nl2br } from '../../utils/misc';
import DetailIcon from '../ui/DetailIcon';
import ExpandableContent from '../ui/ExpandableContent';
import { productAttributes } from './productPresentation';

export default function ProductInfo({ product, descriptionTitle }) {
  const { t } = useTranslation('product');
  const attributes = productAttributes(product);
  return <div className="grid items-start gap-8 lg:grid-cols-2 lg:gap-10">
    <section id="product-description" aria-labelledby="product-description-title" className="min-w-0 scroll-mt-24">
      <h2 id="product-description-title" className="mb-5 text-2xl font-black tracking-tight">{descriptionTitle || t('info.description')}<span className="text-teal-700">.</span></h2>
      {product.description ? <ExpandableContent key={product.description} moreLabel={t('info.more')} lessLabel={t('info.less')}>
        <div className="max-w-[75ch] break-words text-sm leading-7 text-krit-surface [&_p+p]:mt-4 [&_ul]:my-4 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-4 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-2 [&_a]:underline [&_img]:max-w-full [&_table]:block [&_table]:overflow-auto"
          dangerouslySetInnerHTML={{__html: nl2br(product.description, false)}} />
      </ExpandableContent> : <p className="text-sm text-krit-muted">{t('info.noDescription')}</p>}
    </section>
    {attributes.length > 0 && <section id="product-specs" aria-labelledby="product-specs-title" className="min-w-0 scroll-mt-24 rounded-2xl bg-krit-paper px-5 py-6 sm:px-7">
      <div className="mb-5 flex items-center justify-between gap-4">
        <h2 id="product-specs-title" className="text-xl font-black">{t('info.details')}</h2><DetailIcon name="box" className="h-6 w-6 text-krit-muted" />
      </div>
      <dl className="grid gap-x-8 gap-y-5 text-sm sm:grid-cols-2">
        {attributes.map((attribute, index) => <div key={`${attribute.name}-${index}`}>
          <dt className="mb-1.5 break-words text-xs text-krit-muted">{attribute.name}</dt>
          <dd className="break-words font-bold text-krit-ink">
            {attribute.type === 'link' && /^(https?:\/\/|\/(?!\/))/.test(attribute.value) ? <a href={attribute.value} target="_blank" rel="noopener noreferrer" className="underline underline-offset-4">{attribute.description || t('info.link')} ↗</a> : attribute.value}
          </dd>
        </div>)}
      </dl>
    </section>}
  </div>;
}
